import getListing from "./getListing.api";
import getAccessRight from "./getAccessRight.api";
import updateRole from "./updateRole.api";
import getAdminRoleDropdown from "./getAdminRoleDropdown.api";
import createRole from "./createRole.api";
import roleDropdown from "./roleDropdown.api";

const adminRolesApi = {
  getListing,
  getAccessRight,
  updateRole,
  getAdminRoleDropdown,
  createRole,
  roleDropdown,
};

export default adminRolesApi;
